import React from 'react'
import { h } from '@app/helpers/translationHelper'

import Reviews from './Reviews'
import MassMedia from './MassMedia'
import Partners from './Partners'

const About = (props) => {
  return (
    <div className="about-section">
      <Reviews {...props} />
    </div>
  )
}

export default About
